import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Search, Trash} from 'react-feather';
import { removingAnnotation } from '../../Utils/helpers';
import AdviceSearchAnnotationModal from './AdviceSearchAnnotationModal';
import ShowSummaryModalComponent from './ShowSummaryModalComponent';
import QuestionPromptComponent from './PromptCreatorComponent';

const annotationComponentTextStyle = {
  textAlign: 'left'
};

function AnnotationComponent(props) {
  const [adviceModalShow, setAdviceModalShow] = useState(false);
  //const [questionModalShow, setQuestionModalShow] = useState(false);

  const [searchComponentVisibility] = useState(props.searchComponentShow);
  const [deleteComponentVisibility] = useState(props.deleteComponentShow);
  const [summaryComponentVisibility] = useState(props.summaryComponentShow);
  const [annotationCustomerViewVisibility] = useState(props.annotationCustomerView);




  return (
    <div>
      <form id="form-id">
        <div id="match" className="handwai-text-label-normal" style={annotationComponentTextStyle}>
          <br />
          <div className="handwai-text-label-normal" style={annotationComponentTextStyle}>
            <div className="form-group">
              <label htmlFor="ursache">Ursache</label>
              <input className="form-control handwai-input" id="ursache" placeholder="Ursache" readOnly />
            </div>
            {!annotationCustomerViewVisibility && <div className="form-group">
              <label htmlFor="norm">AI-Tag</label>
              <input className="form-control handwai-input" id="norm" placeholder="AI-Tag" />
            </div>}
            <div className="form-group">
              <label htmlFor="agl">AGL</label>
              <input className="form-control handwai-input" id="agl" placeholder="AGL" readOnly />
            </div>
            {annotationCustomerViewVisibility && <>
              <br /><p>Empfehlung</p>
              <textarea readOnly
                rows="15"
                id="Empfehlung"
                placeholder="Empfehlung"
                className="form-control handwai-input"
                style={{ height: 665 }}
              >
              </textarea>
            </>}
            {!annotationCustomerViewVisibility && <>
              <div className="form-group">
                <label htmlFor="advice">Advice</label>
                <textarea className="form-control handwai-input" id="advice" placeholder="ADVICE" />
              </div>
              <div className="form-group">
                <label htmlFor="kommentor">Kommentar</label>
                <textarea className="form-control handwai-input" id="kommentor" placeholder="Kommentar" />
              </div>
              <div className="form-group">
                <label htmlFor="formel">Formel</label>
                <input className="form-control handwai-input" id="formel" placeholder="Formel" />
              </div>
            </>}
            <br />
            <div className="form-inline">
              {searchComponentVisibility && (<Button
                onClick={() => {
                  localStorage.setItem('isChange', 'Yes');
                  setAdviceModalShow(true);
                }}
                className="handwai-btn-report"
              >
                <Search /> Suchen
              </Button>)}
              &emsp;
              {deleteComponentVisibility && (<Button
                onClick={async () => {
                  let state = await props.annotationData
                  let selectedAnnotationID = localStorage.getItem('annotationID')
                  alert(selectedAnnotationID)
                  removingAnnotation(selectedAnnotationID, state)
                  let newData = state.annotations.filter((obj) => obj.unique_id !== selectedAnnotationID);
                  let newState = state
                  newState.annotations = newData
                  props.setAnnotationData(newState);
                }}
                className="handwai-btn-logout"
              >
                <Trash /> Löschen
              </Button>)}
              &emsp;
              {summaryComponentVisibility && <ShowSummaryModalComponent annotationData={props.annotationData}
                setAnnotationData={props.setAnnotationData} />}
              &emsp;
              <br />
              <br />
             <QuestionPromptComponent
             lvreportDisplay={props.lvreportDisplay}/>
            </div>
          </div>
        </div>
      </form>

      <AdviceSearchAnnotationModal
        advicelist={props.advicelist}
        lvid={props.lvid}
        annotationData={props.annotationData}
        setAnnotationData={props.setAnnotationData}
        show={adviceModalShow}
        onHide={() => setAdviceModalShow(false)}
      />


    </div>
  );
}

export default AnnotationComponent;
